import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EntityPagedRequestParameters, EntityOrderedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { SolicitacaoHonra } from 'src/app/model/solicitacao-honra.model';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import Utils from 'src/app/shared/fgi-utils';


@Component({
    selector: 'app-solicitacao-honra-listagem',
    templateUrl: './solicitacao-honra-listagem.component.html',
    styleUrls: ['./solicitacao-honra-listagem.component.scss'],
    standalone: false
})
export class SolicitacaoHonraListagemComponent implements OnInit {
  
  private agentesFinanceiros: AgenteFinanceiro[] = [];

  @Input() public solicitacoesHonra: SolicitacaoHonra[];
  @Input() public atributosPaginacao: EntityPagedRequestParameters;
  @Input() public mostrarExportarSolicitacoes: boolean;
  @Input() public ehAgenteFinanceiro: boolean;
  
  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  @Output() public aoExportarSolicitacoes: EventEmitter<any> = new EventEmitter<any>();

  constructor( private activatedRoute: ActivatedRoute,) {
    this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes']; //resolver
  }

  public opcoesPaginacao: number[];
  public atributosOrdenacao: EntityOrderedRequestParameters;

  public ngOnInit() {
    if (!this.atributosPaginacao) {
      this.atributosPaginacao = <any> {};
    }
    if (this.mostrarExportarSolicitacoes == undefined) {
      this.mostrarExportarSolicitacoes = true;
    }
    this.opcoesPaginacao = [10, 15, 20];
    this.atributosOrdenacao = {
      atributo: '',
      sentido: 'asc'
    }
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    console.log("ORDENAÇÃO: ", novaOrdenacao);
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    let funcao = undefined;
    if (ord.atributo == 'valorEstimadoHonra') {
      funcao = parseFloat;
    }
    this.solicitacoesHonra = this.solicitacoesHonra.sort((a, b) => {
      if (ord.sentido == "asc") {
        return Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      }
      else {
        return -1 * Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      }
    });
  }

  private nomeAgente(cnpj: string) {
    return Utils.nomeAgentePorCNPJ(cnpj, this.agentesFinanceiros);
  }

  exportarSolicitacoesHonra(){
    this.aoExportarSolicitacoes.emit();
  }

}
